// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/visit4 */
export async function visit4ControllerUpdate(
	body: API.Visit4UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit4', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit4/${param0} */
export async function visit4ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit4ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit4ViewResponse>(`/api/visit4/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit4/${param0} */
export async function visit4ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit4ControllerCreateParams,
	body: API.Visit4CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit4/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
